(() => {
  const updateStickyHeaders = () => {
    const forms = document.querySelector('[data-griffe-forms]');
    document.querySelectorAll('.site-header--sticky').forEach((header) => {
      const distance = forms
        ? header.getBoundingClientRect().bottom - forms.getBoundingClientRect().bottom
        : window.scrollY;
      const progress = Math.min(1, Math.max(0, distance) / 160);
      header.classList.toggle('site-header--scrolled', distance > (forms ? 0 : 24));
      header.style.setProperty('--header-scroll-opacity', (progress * 0.95).toFixed(3));
      header.style.setProperty('--header-scroll-blur', (progress * 12).toFixed(2) + 'px');
    });
  };

  const updateHeaderOffset = () => {
    const header = document.querySelector('.site-header--sticky');
    const height = header ? Math.ceil(header.getBoundingClientRect().height) : 0;
    document.documentElement.style.setProperty('--sticky-header-offset', height + 'px');
  };

  let navigationFrame;

  const updateHeaderNavigation = () => {
    window.cancelAnimationFrame(navigationFrame);
    navigationFrame = window.requestAnimationFrame(() => {
      updateHeaderOffset();
      updateStickyHeaders();
      document.querySelectorAll('[data-site-header]').forEach((header) => {
        header.classList.remove('site-header--navigation-overflow');

        if (header.dataset.navigationMode !== 'auto' || window.matchMedia('(max-width: 899px)').matches) return;

        const regions = [
          header.querySelector('.site-header__navigation'),
          header.querySelector('.site-header__brand'),
          header.querySelector('.site-header__actions'),
        ]
          .filter(Boolean)
          .map((element) => element.getBoundingClientRect())
          .filter((rectangle) => rectangle.width > 0)
          .sort((first, second) => first.left - second.left);

        const hasOverlap = regions.some((rectangle, index) => {
          const nextRectangle = regions[index + 1];
          return nextRectangle ? rectangle.right + 16 > nextRectangle.left : false;
        });

        if (hasOverlap) header.classList.add('site-header--navigation-overflow');
      });
    });
  };

  if (!window.navelisStickyHeaderBound) {
    window.navelisStickyHeaderBound = true;
    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape' || event.defaultPrevented) return;
      const menu = event.target.closest('.mobile-menu[open], .nav-dropdown[open], .header-search[open]');
      if (!menu) return;
      event.preventDefault();
      event.stopPropagation();
      menu.open = false;
      menu.querySelector(':scope > summary')?.focus();
    });
    document.addEventListener('toggle', (event) => {
      const menu = event.target;
      if (!menu.matches?.('.header-search, .mobile-menu, .nav-dropdown') || !menu.open) return;
      document.querySelectorAll('.header-search[open], .mobile-menu[open], .nav-dropdown[open]').forEach(other => {
        if (other !== menu && !other.contains(menu) && !menu.contains(other)) other.open = false;
      });
      if (menu.matches('.header-search')) menu.querySelector('input[type="search"]')?.focus({ preventScroll: true });
    }, true);
    document.addEventListener('click', (event) => {
      document.querySelectorAll('.header-search[open], .mobile-menu[open], .nav-dropdown[open]').forEach(menu => {
        if (!menu.contains(event.target) || event.target.closest('a[href]')) menu.open = false;
      });
    });
    window.addEventListener('scroll', updateStickyHeaders, { passive: true });
    window.addEventListener('resize', updateHeaderNavigation, { passive: true });
    document.addEventListener('shopify:section:load', () => {
      updateStickyHeaders();
      updateHeaderNavigation();
    });
    document.fonts?.ready.then(updateHeaderNavigation);
  }

  updateStickyHeaders();
  updateHeaderNavigation();
})();
